"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FilledStar = function FilledStar(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 11 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 10 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 11 10",
    scale: width / 11,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.659.352A.594.594 0 0 1 5 .039c.15-.052.3-.052.449 0 .15.052.263.156.342.313l1.27 2.578 2.85.41c.17.026.303.104.401.234.098.13.143.274.137.43a.6.6 0 0 1-.186.41l-2.07 2.012.488 2.851a.617.617 0 0 1-.088.44.573.573 0 0 1-.361.263.602.602 0 0 1-.45-.058L5.226 8.594 2.667 9.922a.602.602 0 0 1-.45.058.573.573 0 0 1-.36-.263.617.617 0 0 1-.089-.44l.488-2.851-2.07-2.012a.6.6 0 0 1-.185-.41.652.652 0 0 1 .136-.43.593.593 0 0 1 .4-.234l2.852-.41L4.66.352z",
    id: "filledStar"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#filledStar"
  }));
};

var _default = FilledStar;
exports["default"] = _default;
module.exports = exports["default"];